import { api } from '../api';

export const InteriorItemAPI = {
	GetInteriorItemPurchaseStatus: (member_se) =>
		api.get(`api/event/interior-item/week?member_se=${member_se}`),
};
